<template>
  <div class="guests">
    <small>
      Wpisz nazwiska gości ręcznie lub wklej listę z zachowaniem zasady „każdy wiersz to osobne zaproszenie.
    </small>
    <ul class="items">
      <li v-for="(item, index) in scene.guests" :class="{ 'active': index == previewGuestIndex}" :key="index" @click="handleGuestClick(index)">
        {{ index + 1 }}. {{ item.display }}
        <span class="buttons">
          <i class="duplicate el-icon-document-copy" @click.stop="handleDuplicateGuest(index)" />
          <i class="close el-icon-close" @click.stop="handleRemoveGuest(index)" />
        </span>
      </li>
    </ul>
    <el-form class="guest-form" ref="form" :model="guests" label-width="220px">
      <!-- <el-form-item label="...............................................................................">
        <el-input-number v-model="guests.empty" controls-position="right" size="mini" :min="0" @change="handleEmptyChange"></el-input-number>
      </el-form-item> -->
      <el-form-item label-width="0">
        <textarea id="guestField" ref="guestField" v-model="guests.value" placeholder="Uzupełnij ręcznie lub wklej listę i potwierdź ENTER" @keyup.enter="saveGuests">
        </textarea>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Editor from '../../classes/Editor'

export default {
  name: 'Guests',
  props: ['sceneIndex'],
  data() {
    return {
      guests: {
        // empty: 0,
        value: '',
      },
    };
  },
  computed: {
    ...mapGetters('creator', ['scene', 'previewGuest', 'previewGuestIndex', 'isPreview']),
  },
  methods: {
    ...mapActions('creator', ['setSceneGuests', 'removeSceneGuest', 'setPreviewGuest', 'setGuestPosition', 'setPreviewGuestIndex']),

    saveGuests() {
      const guests = this.guests.value.split(/\r\n|\n|\r/)
                         .filter((item) => item.length)
                         .map((item) => ({
                           x: 0,
                           y: 0,
                           content: item,
                           display: item 
                         }));

      this.setSceneGuests({
        scene: this.sceneIndex,
        guests: [...this.scene.guests, ...guests],
      });
      this.guests.value = '';
      this.handleGuestClick(this.scene.guests.length - 1)
    },
    handleDuplicateGuest(guestIndex) {
      this.setSceneGuests({
        scene: this.sceneIndex,
        guests: [...this.scene.guests.slice(0, guestIndex), this.scene.guests[guestIndex], ...this.scene.guests.slice(guestIndex, this.scene.guests.length)],
      });
    },
    handleRemoveGuest(guestIndex) {
      this.removeSceneGuest({
        scene: this.sceneIndex,
        guestIndex
      })
    },
    handleGuestClick(guestIndex) {
      this.setPreviewGuestIndex(guestIndex);
      Editor.setPreview(this.previewGuest)
    },
  },
  mounted() {
    console.log('mounted guests')
    // this.guests.empty = this.scene.emptyGuest

    // Editor.addCallback('mouse:dblclick', (e) => {
    //   console.log('dbclick e', e)
    //   if (e.target.id === 'personalizedField' && !this.isPreview) {
    //     // e.target.editable = true
    //     this.setPreviewGuestIndex(0);
    //     this.$nextTick(() => {
    //       console.log('this.scene.guests[0]', this.scene.guests[0])
    //       Editor.setPreview(this.scene.guests[0])
    //       this.$refs.guestField.focus()
    //     })
    //   }
    // })

    // Editor.addCallback('text:changed', (e) => {
    //   if (e.target.id === 'personalizedField') {
    //     console.log('override guest text')
    //     this.setPreviewGuest({ content: e.target.text, display: e.target.text })
    //   }
    // })

    // Editor.addCallback('object:moving', (e) => {
    //   if (e.target.id === 'personalizedField') {
    //     console.log('override guest position')
    //     this.setGuestPosition({ x: e.target.left, y: e.target.top })
    //   }
    // })

    // Editor.addCallback(['selection:created', 'selection:updated'], () => {
      // if (Editor.canvas.getActiveObject().id === 'personalizedField') {
        
      //   if (this.scene.guests.length) {
      //     console.log('has guest')
      //     this.handleGuestClick(0)
      //   } else {
      //     console.log('no guest', this.$refs.guestField)
      //     this.$refs.guestField.focus()
      //   }
      // }
    // })
  }
};
</script>

<style lang="less">
.el-input-number.is-controls-right {
  width: 70px;
  max-width: 70px;
  .el-input__inner {
    padding-right: 35px;
    padding-left: 5px;
  }
}

textarea {
  width: 100%;
  max-width: 100%;
  border: 1px solid #ccc;
  padding: 5px 10px;
  box-sizing: border-box;
  border-radius: 3px;
  margin-top: 10px;
  &::placeholder {
    font: 12px/16px 'Raleway';
  }
}
.items {
  list-style: none;
  margin: 10px 0;
  padding: 0;
  max-height: 150px;
  overflow: auto;

  li {
    padding: 5px 10px;
    background: #f4f4f5;
    color: #909399;
    border-radius: 3px;
    font-size: 13px;
    cursor: pointer;
    transition: background .3s;
    display: flex;
    align-items: center;

    &:hover {
      background: #eee;
    }

    &.active {
      color: #fff;
      background: #e6a23c;
    }

    .buttons {
      margin-left: auto;
    }

    .close {
      cursor: pointer;
      padding: 0 5px;
    }
    
    + li {
      margin-top: 5px;
    }
  }
}
</style>
